<script>
    import Route, {router} from "../lib/Router/Router.svelte";
    import A from "../lib/Router/A.svelte";
    import R, {LOADER} from "../lib/requests";
    import app from "../stores/app";
    import user from "../stores/user";
    import {sort} from "../lib/lib";
    import PageHeader from "../components/PageHeader.svelte";
    import Icon from "../components/Icon.svelte";
    import TableHeader from "../components/TableHeader.svelte";
    import WorkspaceServiceEdit from "./WorkspaceServiceEdit.svelte";
    // import ServiceEdit from "./ServiceEdit.svelte";
    import ColoredAcronym from "../components/controls/ColoredAcronym.svelte";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";

    let services = null;

    const pageHeaderControls = [
        {key: 'create', name: 'ΔΗΜΙΟΥΡΓΙΑ'},
        {key: 'reload', name: '', icon: 'refresh'}
    ];

    const tableColumns = [
        {key: 'name', title: 'ΟΝΟΜΑ', sortable: true, sort_way: 'ASC'},
        {key: '', title: ''},
    ];

    let serviceId = 0;

    const load = async () => {

        const onSuccess = result => {
            services = result;
        }

        const onFailure = err => {
        };

        await R.handle(R.ws_service.index, {}, onSuccess, onFailure, LOADER.PAGE);
    };


    const onCreateService = () => {
        router.go(`/app/ws-service/create`)(0)
    }

    const onEditService = (service) => {
        router.go(`/app/ws-service/edit/${service.id}`)();
    }

    const onDeleteService = () => {

    }

    const updateService = (service) => {
        let srv = services.find(x => x.id === service.id);
        if (!srv) {
            services = [service, ...services];
        } else {
            srv.name = service.name;
        }
        serviceId = service.id;
    }

    const onColumnSort = ({detail: column}) => {
        services.sort_column = column;
        sortList();
    };

    const sortList = () => {
        services = sort(services, services.sort_column.key, services.sort_column.sort_way === 'DESC');
    }

    load();
</script>
<Route exact>
    <PageHeader title="Είδη Υπηρεσιών" controls={ pageHeaderControls } on:create={ onCreateService }
                on:reload={ load }/>
    <div class="panel panel-default">
        <div class="panel-heading">
            <div class="title-sm">Υπηρεσίες</div>
        </div>
        <div class="panel-body">
            <table class="table table-list table-list-border">
                <TableHeader {tableColumns} on:sort={ onColumnSort }/>
                <tbody>
                {#if services}
                    {#if services.length}
                        {#each services as service}
                            <tr class="row-hover" class:row-selected="{ serviceId === service.id }">
                                <td class="pointer" on:click="{ () => onEditService(service) }">
                                    <ColoredAcronym acronymName={ service.name } name={ service.name }
                                                    color={ service.color }/>
                                </td>
                                <td class="button-column">
                                    <button class="button" on:click="{ () => onDeleteService(service) }">
                                        <Icon name="trash"/>
                                    </button>
                                </td>
                            </tr>
                        {/each}
                    {:else}
                        <tr>
                            <td class="text-muted" colspan="{ tableColumns.length }">
                                <p>
                                    Δεν υπάρχουν υπηρεσίες
                                </p>
                                <button class="btn btn-primary" on:click="{ onCreateService }">ΔΗΜΙΟΥΡΓΙΑ ΥΠΗΡΕΣΙΑΣ
                                </button>
                            </td>
                        </tr>
                    {/if}
                {/if}
                </tbody>
            </table>
        </div>
    </div>
</Route>
<Route match="create">
    <WorkspaceServiceEdit editCallback="{ updateService }" serviceId="{0}"/>
</Route>
<Route match="edit" let:router>
    <WorkspaceServiceEdit editCallback="{ updateService }" serviceId="{ router.id }"/>
</Route>
